import React from 'react';
import DefaultWidthContainer from '../../Layout/Containers/DefaultWidthContainer';
import MediumWidthContainer from '../../Layout/Containers/MediumWidthContainer';
import PageHeaderComponent from '../../util/PageHeader/PageHeaderComponent';
import styles from './insurancePage.module.scss';

const BenefitsPageComponent = () => (
    <>
        <PageHeaderComponent heading="Benefits">Why Noria Insurance Software</PageHeaderComponent>
        <DefaultWidthContainer>
            <h2 id="insurance-companies-and-agencies" className={styles.offeringsH2}>
                Insurance Companies and Agencies
            </h2>
            <p className={styles.offeringsText}>
                A more in-depth description of our insurance companies and agencies will come soon.
            </p>
        </DefaultWidthContainer>
        <MediumWidthContainer>
            <hr className={styles.offeringsHr} />
        </MediumWidthContainer>
        <DefaultWidthContainer>
            <h2 id="marine-and-energy" className={styles.offeringsH2}>
                Marine & Energy
            </h2>
            <p className={styles.offeringsText}>
                Built upon our in-depth knowledge and long insurance experience, Noria Insurance
                solutions offer a comprehensive Marine & Energy insurance business functionality.
                Benefits include efficiency gains, self-service for all stakeholders, business
                agility, information consistency, a single source of data entry, automatic workflow,
                and easy Solvency II reporting. Our clients gain access to proactive and
                comprehensive risk management that is ideal for a global and changing business
                environment.
            </p>
            <h3 className={styles.offeringsH3}>We have the experience</h3>
            <p className={styles.offeringsText}>
                With more than 40 years delivery track in marine and energy sector, we have deep
                understanding in insurance marketplace, processes and opportunities. We develop
                solutions tailored to your requirements.
            </p>
            <h3 className={styles.offeringsH3}>
                Complete Marine & Energy Insurance Business Functionality
            </h3>
            <p className={styles.offeringsText}>
                A pre-built solution, configured for marine and energy insurers
            </p>
            <h3 className={styles.offeringsH3}>
                Business Agility. Ideal for Global and Changing Business Environment
            </h3>
            <p className={styles.offeringsText}>
                Flexibility and breadth of functionality allow you to capitalize on new market needs
                by introducing new products to the market quickly.
                <br />
                <br />
                Scalable and designed to meet global business’ needs, our solution is easily
                deployed across multiple entities and countries and all currencies.
            </p>
            <h3 className={styles.offeringsH3}>One Source of Data Entry</h3>
            <p className={styles.offeringsText}>
                Our insurance solution stores and updates data across all locations simultaneously.
                This reduces the need for updating information in several places, lowering risk, and
                further enhancing efficiency. Improved data quality and efficiency, data is entered
                once and into one system.
            </p>
            <h3 className={styles.offeringsH3}>Automatic Workflow</h3>
            <p className={styles.offeringsText}>
                Enabled by a modern multi-layer architecture, our solutions help insurers enhance
                efficiency through fully automated workflow.
            </p>
            <h3 className={styles.offeringsH3}>
                Self-service and integration of all stakeholders in the insurance process
            </h3>
            <h3 className={styles.offeringsH3}>Web portals for mobile working</h3>
            <p className={styles.offeringsText}>
                Noria web portals e.g., claim portal can easily be accessed from any device through
                a web browser. Our portals store data on the server enables users to pick up where
                they left off, on any device at any location.
            </p>
            <h3 className={styles.offeringsH3}>Solvency II reporting</h3>
            <p className={styles.offeringsText}>
                Our solution provides full audit trail for all transactions and support for Solvency
                II compliant reporting for insurers to meet regulatory requirements.
            </p>
            <h3 className={styles.offeringsH3}>Cost Efficiency</h3>
            <p className={styles.offeringsText}>
                A proven implementation model allows quick onboarding, and the breadth of
                functionality in Noria Insurance Solutions means that little, if any, custom
                development is needed. This means cost-efficient acquisition cost to your
                organisation. Annual license fees are predictable - better control over your IT
                budget.
            </p>
            <h3 className={styles.offeringsH3}>Solid Reinsurance Module</h3>
            <p className={styles.offeringsText}>
                Developed over 30 years in cooperation with world leading marine & energy insurance
                carriers.
            </p>
        </DefaultWidthContainer>
        <MediumWidthContainer>
            <hr className={styles.offeringsHr} />
        </MediumWidthContainer>
        <DefaultWidthContainer extraStyles={{ paddingBottom: '80px' }}>
            <h2 id="captive-insurance" className={styles.offeringsH2}>
                Captive Insurance
            </h2>
            <p className={styles.offeringsText}>
                Noria Insurance Solutions provide captive insurers with a single insurance system
                for all business processes. Some benefits include:
            </p>
            <h3 className={styles.offeringsH3}>
                Single Insurance Solutions for all business processes
            </h3>
            <p className={styles.offeringsText}>
                All business functions in the same IT platform that always keeps information updated
                across all modules.
            </p>
            <h3 className={styles.offeringsH3}>We help you with implementation</h3>
            <p className={styles.offeringsText}>
                Over 40 years in business and a 100% success rate in customer implementations means
                lower risk for your project.
            </p>
            <h3 className={styles.offeringsH3}>One Source of Data Entry</h3>
            <p className={styles.offeringsText}>
                Our insurance solution stores and updates data across all locations simultaneously –
                thanks to a solid data model. This reduces the need for updating information in
                several places, lowering risk, and further enhancing efficiency. Improved data
                quality and efficiency, data is entered once and into one system.
            </p>
            <h3 className={styles.offeringsH3}>Predictability of costs</h3>
            <p className={styles.offeringsText}>
                We understand how important this is for you. Our cost-efficient platform has been
                designed to provide you with an unmatched richness of functionality and
                configurability to ensure that minimal, if any, customisation is required.
            </p>
            <h3 className={styles.offeringsH3}>Solid reinsurance module</h3>
            <p className={styles.offeringsText}>
                Developed over 30 years in cooperation with world leading marine & energy insurance
                carriers.
            </p>
            <h3 className={styles.offeringsH3}>Manage Multiple Entities</h3>
            <h3 className={styles.offeringsH3}>Web portals for mobile working</h3>
            <p className={styles.offeringsText}>
                Built to meet complex requirements, PARIS for Captives is an ideal platform whether
                your business comprises of a single or several entities, in one jurisdiction or
                across several jurisdictions.
            </p>
            <h3 className={styles.offeringsH3}>Solvency II reporting</h3>
            <p className={styles.offeringsText}>
                Our solution provides full audit trail for all transactions and support for Solvency
                II compliant reporting for insurers to meet regulatory requirements.
            </p>
            <h3 className={styles.offeringsH3}>Business Intelligence and Insights</h3>
            <p className={styles.offeringsText}>
                Our Insurance Software’s dashboards with real-time data and comprehensive reporting
                tool ensure that you have better control, and you have the information to support
                risk management and business decisions. This means transparency to KPIs and support
                for your decision-making with real time business insights.
            </p>
            <h3 className={styles.offeringsH3}>Comprehensive Customer Care</h3>
            <p className={styles.offeringsText}>
                We offer tailored trailing solutions to ensure optimal use of the platform, support
                to help when needed and upgrades when new versions of the platform are made
                available.
            </p>
            <h3 className={styles.offeringsH3}>Workflow Web Portal</h3>
            <p className={styles.offeringsText}>
                Whether your claims handling is outsourced or handled with in-house resources, our
                Claims web portal is a powerful and user-friendly tool to manage claims.
            </p>
        </DefaultWidthContainer>
    </>
);

export default BenefitsPageComponent;
